/**
 * Log actions and middleware for the store. Firing the actions will result in logs!
 */
import { Logger, LogLevel } from '@dora/lumberjack';
import type { Middleware } from 'redux';
import * as LogActions from '../actions/logging';

const logger = new Logger('Fixtuur', LogLevel.Info);

export function getLogger(): Logger {
    return logger;
}

export function setLogLevel(level: LogLevel) {
    logger.setOutputLogLevel(level);
}

export const middleware: Middleware =
    ({}) =>
    next =>
    action => {
        if (action.type === LogActions.logActionType) {
            const logMessage = action.payload.message;
            const logContext = action.payload.context;

            logger.log(action.payload.level, logMessage, logContext);
        }
        return next(action);
    };
